// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
[data-component='ConsolePage'] {
  font-family: 'Roboto Mono', monospace;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0%;
  overflow: auto;
  margin: 0px 20px; }
  [data-component='ConsolePage'] > div {
    flex-shrink: 0; }
  [data-component='ConsolePage'] .spacer {
    flex-grow: 0; }
  [data-component='ConsolePage'] .content-main {
    flex-grow: 1;
    flex-shrink: 1 !important;
    margin: 0px 16px;
    display: flex;
    overflow: hidden;
    margin-bottom: 0%; }
    [data-component='ConsolePage'] .content-main .content-block {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%; }
      [data-component='ConsolePage'] .content-main .content-block .content-block-title {
        flex-shrink: 0;
        color: gray;
        padding-top: 16px;
        font-size: 26px;
        padding-bottom: 4px;
        position: relative;
        display: flex;
        /* Flexbox aktif */
        justify-content: center;
        /* Yatay ortalama */
        align-items: center;
        /* Dikey ortalama */
        height: 100%;
        /* Ebeveyn yüksekliği */
        text-align: center;
        /* Çok satırlı metinler için merkezleme */ }
      [data-component='ConsolePage'] .content-main .content-block .content-block-body {
        color: #6e6e7f;
        position: relative;
        flex-grow: 1;
        height: 100%;
        padding: 10px 0px;
        padding-top: 4px;
        line-height: 1.2em;
        overflow: auto; }
        [data-component='ConsolePage'] .content-main .content-block .content-block-body.full {
          padding: 0px; }
    [data-component='ConsolePage'] .content-main .content-logs {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden; }
      [data-component='ConsolePage'] .content-main .content-logs > div {
        flex-grow: 1; }
      [data-component='ConsolePage'] .content-main .content-logs > .content-actions {
        flex-grow: 0;
        flex-shrink: 0;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        margin-top: 0%;
        margin-bottom: 1%; }
      [data-component='ConsolePage'] .content-main .content-logs > div.events {
        overflow: hidden; }
      [data-component='ConsolePage'] .content-main .content-logs .events {
        border-top: 1px solid #e7e7e7; }
      [data-component='ConsolePage'] .content-main .content-logs .conversation {
        display: flex;
        flex-shrink: 0;
        width: 100%;
        overflow: hidden;
        padding-top: 0px;
        height: 500px;
        min-height: 0;
        border-top: 1px solid #e7e7e7; }
  [data-component='ConsolePage'] .conversation-item {
    position: relative;
    padding-top: 16px;
    display: flex;
    gap: 16px; }
    [data-component='ConsolePage'] .conversation-item:not(:hover) .close {
      display: none; }
    [data-component='ConsolePage'] .conversation-item .close {
      position: absolute;
      top: 0px;
      right: -20px;
      background: #aaa;
      color: #fff;
      display: flex;
      border-radius: 16px;
      padding: 2px;
      cursor: pointer; }
      [data-component='ConsolePage'] .conversation-item .close:hover {
        background: #696969; }
      [data-component='ConsolePage'] .conversation-item .close svg {
        stroke-width: 3;
        width: 12px;
        height: 12px; }
    [data-component='ConsolePage'] .conversation-item .speaker {
      position: relative;
      text-align: left;
      gap: 16px;
      width: 80px;
      flex-shrink: 0;
      margin-right: 16px; }
      [data-component='ConsolePage'] .conversation-item .speaker.user {
        color: #0099ff; }
      [data-component='ConsolePage'] .conversation-item .speaker.assistant {
        color: #009900; }
    [data-component='ConsolePage'] .conversation-item .speaker-content {
      color: #18181b;
      overflow: hidden;
      word-wrap: break-word; }
  [data-component='ConsolePage'] .event {
    border-radius: 3px;
    white-space: pre;
    display: flex;
    padding: 0px;
    gap: 16px; }
    [data-component='ConsolePage'] .event .event-timestamp {
      text-align: left;
      gap: 8px;
      padding: 4px 0px;
      width: 80px;
      flex-shrink: 0;
      margin-right: 16px; }
    [data-component='ConsolePage'] .event .event-details {
      display: flex;
      flex-direction: column;
      color: #18181b;
      gap: 8px; }
      [data-component='ConsolePage'] .event .event-details .event-summary {
        padding: 4px 8px;
        margin: 0px -8px;
        cursor: pointer;
        display: flex;
        gap: 8px;
        align-items: center; }
        [data-component='ConsolePage'] .event .event-details .event-summary:hover {
          border-radius: 8px;
          background-color: #f0f0f0; }
        [data-component='ConsolePage'] .event .event-details .event-summary .event-source {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          gap: 8px; }
          [data-component='ConsolePage'] .event .event-details .event-summary .event-source.client {
            color: #0099ff; }
          [data-component='ConsolePage'] .event .event-details .event-summary .event-source.server {
            color: #009900; }
          [data-component='ConsolePage'] .event .event-details .event-summary .event-source.error {
            color: #990000; }
          [data-component='ConsolePage'] .event .event-details .event-summary .event-source svg {
            stroke-width: 3;
            width: 12px;
            height: 12px; }
  [data-component='ConsolePage'] .visualization {
    position: absolute;
    display: flex;
    bottom: 4px;
    right: 8px;
    padding: 4px;
    padding-right: 44%;
    padding-bottom: 3.65%;
    border-radius: 16px;
    z-index: 10;
    gap: 2px; }
    [data-component='ConsolePage'] .visualization .visualization-entry {
      position: relative;
      display: flex;
      align-items: center;
      height: 40px;
      width: 100px;
      gap: 4px; }
      [data-component='ConsolePage'] .visualization .visualization-entry.client {
        color: #0099ff; }
      [data-component='ConsolePage'] .visualization .visualization-entry.server {
        color: #009900; }
      [data-component='ConsolePage'] .visualization .visualization-entry canvas {
        width: 100%;
        height: 100%;
        color: currentColor; }
`, "",{"version":3,"sources":["webpack://./src/pages/pages/assistant/pages/ConsolePage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EAAE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,gBAAgB,EAAA;EAEhB;IAEE,cAAc,EAAA;EAAhB;IAIE,YAAY,EAAA;EAFd;IAME,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB,EAAA;IAJjB;MAOE,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,WAAW,EAAA;MALX;QAQE,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,kBAAA;QACA,uBAAuB;QACvB,mBAAA;QACA,mBAAmB;QACnB,mBAAA;QACA,YAAY;QACZ,uBAAA;QACA,kBAAkB;QAClB,yCAAA,EAA0C;MAN5C;QAUE,cAAc;QACd,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,cAAc,EAAA;QARd;UAWE,YAAY,EAAA;IATlB;MAeE,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,gBAAgB,EAAA;MAbhB;QAgBE,YAAY,EAAA;MAdd;QAkBE,YAAY;QACZ,cAAc;QACd,aAAa;QACb,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,cAAc;QACd,iBAAiB,EAAA;MAhBnB;QAoBE,gBAAgB,EAAA;MAlBlB;QAsBE,6BAA6B,EAAA;MApB/B;QAwBE,aAAa;QACb,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb,6BAA6B,EAAA;EAtBnC;IA4BE,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,SAAS,EAAA;IA1BT;MA8BE,aAAa,EAAA;IA5Bf;MAgCE,kBAAkB;MAClB,QAAQ;MACR,YAAY;MACZ,gBAAgB;MAChB,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,eAAe,EAAA;MA9Bf;QAiCE,mBAAmB,EAAA;MA/BrB;QAmCE,eAAe;QACf,WAAW;QACX,YAAY,EAAA;IAjChB;MAsCE,kBAAkB;MAClB,gBAAgB;MAChB,SAAS;MACT,WAAW;MACX,cAAc;MACd,kBAAkB,EAAA;MApClB;QAuCE,cAAc,EAAA;MArChB;QAyCE,cAAc,EAAA;IAvClB;MA4CE,cAAc;MACd,gBAAgB;MAChB,qBAAqB,EAAA;EA1CzB;IA+CE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,SAAS,EAAA;IA7CT;MAgDE,gBAAgB;MAChB,QAAQ;MACR,gBAAgB;MAChB,WAAW;MACX,cAAc;MACd,kBAAkB,EAAA;IA9CpB;MAkDE,aAAa;MACb,sBAAsB;MACtB,cAAc;MACd,QAAQ,EAAA;MAhDR;QAmDE,gBAAgB;QAChB,gBAAgB;QAOhB,eAAe;QACf,aAAa;QACb,QAAQ;QACR,mBAAmB,EAAA;QAvDnB;UAgDE,kBAAkB;UAClB,yBAAyB,EAAA;QA9C3B;UAuDE,cAAc;UACd,aAAa;UACb,mBAAmB;UACnB,QAAQ,EAAA;UArDR;YAwDE,cAAc,EAAA;UAtDhB;YA0DE,cAAc,EAAA;UAxDhB;YA4DE,cAAc,EAAA;UA1DhB;YA8DE,eAAe;YACf,WAAW;YACX,YAAY,EAAA;EA5DtB;IAoEE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,QAAQ,EAAA;IAlER;MAqEE,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,QAAQ,EAAA;MAnER;QAsEE,cAAc,EAAA;MApEhB;QAwEE,cAAc,EAAA;MAtEhB;QA0EE,WAAW;QACX,YAAY;QACZ,mBAAmB,EAAA","sourcesContent":["[data-component='ConsolePage'] {\n  font-family: 'Roboto Mono', monospace;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0%;\n  overflow: auto;\n  margin: 0px 20px;\n\n\n  &>div {\n    flex-shrink: 0;\n  }\n\n  .spacer {\n    flex-grow: 0;\n  }\n\n  .content-main {\n    flex-grow: 1;\n    flex-shrink: 1 !important;\n    margin: 0px 16px;\n    display: flex;\n    overflow: hidden;\n    margin-bottom: 0%;\n\n    .content-block {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n      width: 100%;\n\n      .content-block-title {\n        flex-shrink: 0;\n        color: gray;\n        padding-top: 16px;\n        font-size: 26px;\n        padding-bottom: 4px;\n        position: relative;\n        display: flex;\n        /* Flexbox aktif */\n        justify-content: center;\n        /* Yatay ortalama */\n        align-items: center;\n        /* Dikey ortalama */\n        height: 100%;\n        /* Ebeveyn yüksekliği */\n        text-align: center;\n        /* Çok satırlı metinler için merkezleme */\n      }\n\n      .content-block-body {\n        color: #6e6e7f;\n        position: relative;\n        flex-grow: 1;\n        height: 100%;\n        padding: 10px 0px;\n        padding-top: 4px;\n        line-height: 1.2em;\n        overflow: auto;\n\n        &.full {\n          padding: 0px;\n        }\n      }\n    }\n\n    .content-logs {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n\n      &>div {\n        flex-grow: 1;\n      }\n\n      &>.content-actions {\n        flex-grow: 0;\n        flex-shrink: 0;\n        height: 100px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 16px;\n        margin-top: 0%;\n        margin-bottom: 1%;\n      }\n\n      &>div.events {\n        overflow: hidden;\n      }\n\n      .events {\n        border-top: 1px solid #e7e7e7;\n      }\n\n      .conversation {\n        display: flex;\n        flex-shrink: 0;\n        width: 100%;\n        overflow: hidden;\n        padding-top: 0px;\n        height: 500px;\n        min-height: 0;\n        border-top: 1px solid #e7e7e7;\n      }\n    }\n  }\n\n  .conversation-item {\n    position: relative;\n    padding-top: 16px;\n    display: flex;\n    gap: 16px;\n\n\n    &:not(:hover) .close {\n      display: none;\n    }\n\n    .close {\n      position: absolute;\n      top: 0px;\n      right: -20px;\n      background: #aaa;\n      color: #fff;\n      display: flex;\n      border-radius: 16px;\n      padding: 2px;\n      cursor: pointer;\n\n      &:hover {\n        background: #696969;\n      }\n\n      svg {\n        stroke-width: 3;\n        width: 12px;\n        height: 12px;\n      }\n    }\n\n    .speaker {\n      position: relative;\n      text-align: left;\n      gap: 16px;\n      width: 80px;\n      flex-shrink: 0;\n      margin-right: 16px;\n\n      &.user {\n        color: #0099ff;\n      }\n\n      &.assistant {\n        color: #009900;\n      }\n    }\n\n    .speaker-content {\n      color: #18181b;\n      overflow: hidden;\n      word-wrap: break-word;\n    }\n  }\n\n  .event {\n    border-radius: 3px;\n    white-space: pre;\n    display: flex;\n    padding: 0px;\n    gap: 16px;\n\n    .event-timestamp {\n      text-align: left;\n      gap: 8px;\n      padding: 4px 0px;\n      width: 80px;\n      flex-shrink: 0;\n      margin-right: 16px;\n    }\n\n    .event-details {\n      display: flex;\n      flex-direction: column;\n      color: #18181b;\n      gap: 8px;\n\n      .event-summary {\n        padding: 4px 8px;\n        margin: 0px -8px;\n\n        &:hover {\n          border-radius: 8px;\n          background-color: #f0f0f0;\n        }\n\n        cursor: pointer;\n        display: flex;\n        gap: 8px;\n        align-items: center;\n\n        .event-source {\n          flex-shrink: 0;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n\n          &.client {\n            color: #0099ff;\n          }\n\n          &.server {\n            color: #009900;\n          }\n\n          &.error {\n            color: #990000;\n          }\n\n          svg {\n            stroke-width: 3;\n            width: 12px;\n            height: 12px;\n          }\n        }\n      }\n    }\n  }\n\n  .visualization {\n    position: absolute;\n    display: flex;\n    bottom: 4px;\n    right: 8px;\n    padding: 4px;\n    padding-right: 44%;\n    padding-bottom: 3.65%;\n    border-radius: 16px;\n    z-index: 10;\n    gap: 2px;\n\n    .visualization-entry {\n      position: relative;\n      display: flex;\n      align-items: center;\n      height: 40px;\n      width: 100px;\n      gap: 4px;\n\n      &.client {\n        color: #0099ff;\n      }\n\n      &.server {\n        color: #009900;\n      }\n\n      canvas {\n        width: 100%;\n        height: 100%;\n        color: currentColor;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
